import { Component, Injector, OnInit } from '@angular/core';
import { Helpers } from '../../helpers';
import { Store, select } from '@ngrx/store';
import { AppState } from '@app/reducers';
import { agentLoginDataSelector } from './app-header/state/agent-login.selector';
import { RxjsService } from '../services/rxjs.services';
import { AgentLoginService } from '../services/agent-login.service';
import { filter } from 'rxjs/operators';

declare var $: any

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  setindex: number = 0;
  agentExtensionNo: any;
  openScapeOpen = false;
  openChat = false;
  onConnectsAIPopup=false;

  // RxjsService resolved lazily via Injector, not constructor-injected — see the detailed
  // comment in agent-login.service.ts. LayoutComponent is the earliest-loaded root shell, so
  // it's especially exposed to the @app/shared circular-import TDZ. Do not revert to a direct
  // RxjsService constructor param.
  private get rxjsService(): RxjsService {
    return this.injector.get(RxjsService);
  }

  constructor(private readonly store: Store<AppState>,
    private readonly injector: Injector,
    public readonly agentLoginService: AgentLoginService) { }

  ngOnInit() {
    this.store.pipe(select(agentLoginDataSelector)).subscribe((extension: string) => {
      this.agentExtensionNo = extension;
    });
    this.rxjsService
    .getAnyPropertyValue()
    .pipe(filter(data => data?.onConnectsAIPopup !== undefined))
    .subscribe(({ onConnectsAIPopup }) => {
      this.onConnectsAIPopup = onConnectsAIPopup;
    });
  }

  ngAfterViewInit() {

    // initialize layout: handlers, menu ...
    Helpers.initLayout();


  }

  toggleQuickAction() {
    this.rxjsService.setToggleQuickActionComponent(null);
  }

  gotoTop() { }

  onClickChatNotification() {
    this.openChat = true;
  }

}
